import type {MRT_ColumnDef, MRT_RowData} from 'mantine-react-table';

/**
 * Column-def wrapper for list columns whose values are computed on the server
 * after pagination (marked `[ServerComputed]` on the backend DTO): forces
 * `enableSorting: false` and disables column filtering unless the backend
 * hoists that filter id, in which case pass `filterable: true`.
 * @registry Wraps an MRT column def for a server-computed (post-pagination) value — non-sortable always, filterable only by explicit opt-in.
 */
export const serverComputedColumn = <T extends MRT_RowData>({
  filterable = false,
  ...column
}: MRT_ColumnDef<T> & {filterable?: boolean}): MRT_ColumnDef<T> => ({
  ...column,
  enableSorting: false,
  enableColumnFilter: filterable,
});
